import oplog from "./oplog";
const analytics = {
    oplog,
};
export default analytics;
